
// // // src/pages/Login.js
// // import React, { useState } from "react";
// // import { signInWithEmailAndPassword } from "firebase/auth";
// // import { auth } from "../firebase";
// // import { Container, Form, Button } from "react-bootstrap";
// // import { useNavigate } from "react-router-dom";

// // export default function AdminLogin() {
// //   const [email, setEmail] = useState("");
// //   const [password, setPassword] = useState("");
// //   const navigate = useNavigate();

// //   const handleLogin = async () => {
// //     try {
// //       await signInWithEmailAndPassword(auth, email, password);
// //       console.log("Login successful");
// //       navigate("/admin-dashboard"); // Redirect to home page
// //     } catch (error) {
// //       console.error("Login error:", error.code, error.message);
// //       alert(error.message);
// //     }
// //   };

// //   return (
// //     <Container className="mt-4">
// //       <h2>Login</h2>
// //       <Form>
// //         <Form.Group>
// //           <Form.Label>Email</Form.Label>
// //           <Form.Control
// //             type="email"
// //             value={email}
// //             onChange={(e) => setEmail(e.target.value)}
// //           />
// //         </Form.Group>
// //         <Form.Group>
// //           <Form.Label>Password</Form.Label>
// //           <Form.Control
// //             type="password"
// //             value={password}
// //             onChange={(e) => setPassword(e.target.value)}
// //           />
// //         </Form.Group>
// //         <Button className="mt-3" onClick={handleLogin}>
// //           Login
// //         </Button>
// //       </Form>
// //     </Container>
// //   );
// // }

// // src/pages/Login.js
// import React, { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import {
//   signInWithEmailAndPassword,
//   GoogleAuthProvider,
//   signInWithPopup,
//   signInWithRedirect,
//   getRedirectResult,
// } from "firebase/auth";
// import { auth } from "../firebase";
// import {
//   Container,
//   Row,
//   Col,
//   Card,
//   Form,
//   Button,
//   Alert,
//   Spinner,
// } from "react-bootstrap";

// export default function AdminLogin() {
//   const [email, setEmail] = useState("");
//   const [password, setPassword] = useState("");
//   const [busy, setBusy] = useState(false);
//   const [err, setErr] = useState(null);
//   const navigate = useNavigate();

//   // If a redirect-based Google sign-in completed, handle the result.
//   useEffect(() => {
//     (async () => {
//       try {
//         const result = await getRedirectResult(auth);
//         if (result?.user) {
//           navigate("/admin-dashboard");
//         }
//       } catch (e) {
//         // Not fatal; just show error
//         setErr(e);
//       }
//     })();
//   }, [navigate]);

//   const handleLogin = async (e) => {
//     e?.preventDefault?.();
//     setErr(null);
//     try {
//       setBusy(true);
//       await signInWithEmailAndPassword(auth, email.trim(), password);
//       navigate("/admin-dashboard");
//     } catch (error) {
//       console.error("Login error:", error.code, error.message);
//       setErr(error);
//     } finally {
//       setBusy(false);
//     }
//   };

//   const handleGoogleLogin = async () => {
//     setErr(null);
//     const provider = new GoogleAuthProvider();
//     try {
//       setBusy(true);
//       // Try popup first (best UX on desktop)
//       await signInWithPopup(auth, provider);
//       navigate("/admin-dashboard");
//     } catch (popupErr) {
//       // Fallback to redirect for environments where popups fail (e.g., iOS PWA)
//       if (isPopupBlockedOrUnavailable(popupErr)) {
//         try {
//           await signInWithRedirect(auth, provider);
//           // Navigation will happen in useEffect() after redirect result
//         } catch (redirectErr) {
//           console.error("Google redirect error:", redirectErr);
//           setErr(redirectErr);
//           setBusy(false);
//         }
//       } else {
//         console.error("Google popup error:", popupErr);
//         setErr(popupErr);
//         setBusy(false);
//       }
//     }
//   };

//   function isPopupBlockedOrUnavailable(error) {
//     const code = error?.code || "";
//     return (
//       code === "auth/popup-blocked" ||
//       code === "auth/popup-closed-by-user" ||
//       code === "auth/cancelled-popup-request" ||
//       code === "auth/operation-not-supported-in-this-environment"
//     );
//   }

//   return (
//     <Container className="py-5">
//       <Row className="justify-content-center">
//         <Col xs={12} sm={10} md={8} lg={5} xl={4}>
//           <Card className="shadow-sm">
//             <Card.Body className="p-4">
//               <h3 className="mb-3 text-center">Login</h3>

//               {err && (
//                 <Alert variant="danger" className="py-2">
//                   {err?.message || "Authentication failed."}
//                 </Alert>
//               )}

//               {/* Email / Password */}
//               <Form onSubmit={handleLogin}>
//                 <Form.Group className="mb-3" controlId="loginEmail">
//                   <Form.Label>Email</Form.Label>
//                   <Form.Control
//                     type="email"
//                     value={email}
//                     onChange={(e) => setEmail(e.target.value)}
//                     autoComplete="username"
//                     placeholder="you@example.com"
//                     required
//                   />
//                 </Form.Group>

//                 <Form.Group className="mb-2" controlId="loginPassword">
//                   <Form.Label>Password</Form.Label>
//                   <Form.Control
//                     type="password"
//                     value={password}
//                     onChange={(e) => setPassword(e.target.value)}
//                     autoComplete="current-password"
//                     placeholder="Enter your password"
//                     required
//                   />
//                 </Form.Group>

//                 <div className="d-grid mt-3">
//                   <Button
//                     type="submit"
//                     variant="primary"
//                     disabled={busy}
//                     className="d-flex align-items-center justify-content-center gap-2"
//                   >
//                     {busy && <Spinner size="sm" animation="border" />} Log in
//                   </Button>
//                 </div>
//               </Form>

//               {/* Divider */}
//               <div className="d-flex align-items-center my-3">
//                 <div className="flex-grow-1 border-top" />
//                 <div className="px-2 text-muted small">or</div>
//                 <div className="flex-grow-1 border-top" />
//               </div>

//               {/* Google Login */}
//               <div className="d-grid">
//                 <Button
//                   variant="outline-danger"
//                   onClick={handleGoogleLogin}
//                   disabled={busy}
//                   className="d-flex align-items-center justify-content-center gap-2"
//                 >
//                   {/* If you use bootstrap-icons, include <i className="bi bi-google"></i> */}
//                   {busy ? (
//                     <>
//                       <Spinner size="sm" animation="border" /> Connecting…
//                     </>
//                   ) : (
//                     <>Continue with Google</>
//                   )}
//                 </Button>
//               </div>
//             </Card.Body>
//           </Card>

//           {/* Optional: small footer */}
//           <div className="text-center text-muted mt-3 small">
//             © {new Date().getFullYear()} — Admin Access
//           </div>
//         </Col>
//       </Row>
//     </Container>
//   );
// }

// src/pages/Login.js
import React, { useEffect, useMemo, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  signInWithEmailAndPassword,
  GoogleAuthProvider,
  signInWithPopup,
  signInWithRedirect,
  getRedirectResult,
  RecaptchaVerifier,
  signInWithPhoneNumber,
  getIdTokenResult,
  signOut,
} from "firebase/auth";
import { auth } from "../firebase";
import {
  Container,
  Row,
  Col,
  Card,
  Form,
  Button,
  Alert,
  Spinner,
  Nav,
  InputGroup,
} from "react-bootstrap";

// --- Optional: allowlist for admin phone numbers ---
// Replace with your real admin numbers in E.164 format.
// For production, prefer Firebase Custom Claims (shown below).
const ADMIN_PHONE_ALLOWLIST = new Set([
  // "+911234567890",
]);

export default function AdminLogin() {
  const navigate = useNavigate();

  // UI state
  const [tab, setTab] = useState("password"); // 'password' | 'phone'
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState(null);

  // Email/password
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  // Phone/OTP
  const [phone, setPhone] = useState("");
  const [otp, setOtp] = useState("");
  const [confirmationResult, setConfirmationResult] = useState(null);
  const [otpSent, setOtpSent] = useState(false);
  const recaptchaRef = useRef(null); // to hold RecaptchaVerifier instance

  // Handle Google redirect result if previous attempt used redirect
  useEffect(() => {
    (async () => {
      try {
        const result = await getRedirectResult(auth);
        if (result?.user) {
          await postLoginAdminGate(result.user);
        }
      } catch (e) {
        setErr(e);
      }
    })();
    // Cleanup reCAPTCHA verifier on unmount
    return () => {
      if (recaptchaRef.current) {
        recaptchaRef.current.clear();
        recaptchaRef.current = null;
      }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // ---- Helpers ----
  function isPopupBlockedOrUnavailable(error) {
    const code = error?.code || "";
    return (
      code === "auth/popup-blocked" ||
      code === "auth/popup-closed-by-user" ||
      code === "auth/cancelled-popup-request" ||
      code === "auth/operation-not-supported-in-this-environment"
    );
  }

  function normalizePhoneE164(raw) {
    // Trim spaces and unify
    let v = (raw || "").replace(/\s+/g, "");
    // If user types a 10-digit India mobile, auto-prefix +91 for convenience
    if (/^\d{10}$/.test(v)) {
      v = "+91" + v;
    }
    // Ensure it starts with '+' and digits
    if (!/^\+\d{7,15}$/.test(v)) {
      return null; // invalid
    }
    return v;
  }

  async function postLoginAdminGate(user) {
    // Option A (quick): allowlist phone numbers
    if (user.phoneNumber && ADMIN_PHONE_ALLOWLIST.size > 0) {
      if (!ADMIN_PHONE_ALLOWLIST.has(user.phoneNumber)) {
        await signOut(auth);
        throw new Error(
          "Your phone number is not authorized for admin access."
        );
      }
    }

    // Option B (recommended): enforce Firebase Custom Claims (admin=true)
    // Requires setting claims via Admin SDK on the server.
    try {
      const tokenResult = await getIdTokenResult(user, true);
      if (tokenResult?.claims?.admin !== true) {
        // If you rely solely on custom claims, block here
        // await signOut(auth);
        // throw new Error("Your account is not authorized for admin access.");
      }
    } catch (_) {
      // If claim check fails, decide how strict you want to be.
    }

    // If passed, go to admin dashboard
    navigate("/admin-dashboard");
  }

  // ---- Email/Password ----
  const handleLogin = async (e) => {
    e?.preventDefault?.();
    setErr(null);
    try {
      setBusy(true);
      const cred = await signInWithEmailAndPassword(
        auth,
        email.trim(),
        password
      );
      await postLoginAdminGate(cred.user);
    } catch (error) {
      console.error("Login error:", error.code, error.message);
      setErr(error);
    } finally {
      setBusy(false);
    }
  };

  // ---- Google ----
  const handleGoogleLogin = async () => {
    setErr(null);
    const provider = new GoogleAuthProvider();
    try {
      setBusy(true);
      await signInWithPopup(auth, provider);
      await postLoginAdminGate(auth.currentUser);
    } catch (popupErr) {
      if (isPopupBlockedOrUnavailable(popupErr)) {
        try {
          await signInWithRedirect(auth, provider);
          // Redirect result handled in useEffect
        } catch (redirectErr) {
          console.error("Google redirect error:", redirectErr);
          setErr(redirectErr);
          setBusy(false);
        }
      } else {
        console.error("Google popup error:", popupErr);
        setErr(popupErr);
        setBusy(false);
      }
    }
  };

  // ---- Phone/OTP ----
  // Initialize invisible reCAPTCHA on demand
  const ensureRecaptcha = async () => {
    if (recaptchaRef.current) return recaptchaRef.current;

    recaptchaRef.current = new RecaptchaVerifier(
      auth,
      "recaptcha-container",
      {
        size: "invisible", // better UX
        callback: () => {
          // reCAPTCHA solved automatically for invisible; proceed
        },
        "expired-callback": () => {
          // Optionally inform user
        },
      }
    );
    await recaptchaRef.current.render(); // ensure widget is created
    return recaptchaRef.current;
  };

  const handleSendOtp = async (e) => {
    e?.preventDefault?.();
    setErr(null);
    setOtp("");
    setOtpSent(false);
    setConfirmationResult(null);

    const e164 = normalizePhoneE164(phone);
    if (!e164) {
      setErr(new Error("Enter a valid phone number in international format (e.g., +919876543210)."));
      return;
    }

    try {
      setBusy(true);
      const verifier = await ensureRecaptcha();
      const result = await signInWithPhoneNumber(auth, e164, verifier);
      setConfirmationResult(result);
      setOtpSent(true);
    } catch (error) {
      console.error("Send OTP error:", error.code, error.message);
      setErr(error);
      // If something is wrong with reCAPTCHA, reset it
      if (recaptchaRef.current) {
        try {
          recaptchaRef.current.clear();
        } catch { }
        recaptchaRef.current = null;
      }
    } finally {
      setBusy(false);
    }
  };

  const handleVerifyOtp = async (e) => {
    e?.preventDefault?.();
    setErr(null);
    if (!confirmationResult) {
      setErr(new Error("Please request an OTP first."));
      return;
    }
    if (!/^\d{4,8}$/.test(otp)) {
      setErr(new Error("Enter the OTP you received."));
      return;
    }

    try {
      setBusy(true);
      const cred = await confirmationResult.confirm(otp);
      await postLoginAdminGate(cred.user);
    } catch (error) {
      console.error("Verify OTP error:", error.code, error.message);
      setErr(error);
    } finally {
      setBusy(false);
    }
  };

  const PhoneTab = (
    <>
      <Form onSubmit={otpSent ? handleVerifyOtp : handleSendOtp}>
        <Form.Group className="mb-3" controlId="loginPhone">
          <Form.Label>Mobile Number</Form.Label>
          <InputGroup>
            <Form.Control
              type="tel"
              placeholder="+91XXXXXXXXXX"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              disabled={busy || otpSent}
              required
            />
            <Button
              variant="outline-secondary"
              onClick={handleSendOtp}
              disabled={busy || otpSent}
            >
              {busy && !otpSent ? (
                <>
                  <Spinner size="sm" animation="border" /> Sending…
                </>
              ) : (
                "Send OTP"
              )}
            </Button>
          </InputGroup>
          <Form.Text className="text-muted">
            Enter in international format. Tip: Typing 10 digits will auto‑prefix +91.
          </Form.Text>
        </Form.Group>

        {otpSent && (
          <Form.Group className="mb-3" controlId="loginOtp">
            <Form.Label>Enter OTP</Form.Label>
            <Form.Control
              type="text"
              inputMode="numeric"
              value={otp}
              onChange={(e) => setOtp(e.target.value.replace(/\D/g, ""))}
              placeholder="6-digit code"
              required
            />
          </Form.Group>
        )}

        <div className="d-grid mt-2">
          {otpSent ? (
            <Button
              type="submit"
              variant="primary"
              disabled={busy}
              className="d-flex align-items-center justify-content-center gap-2"
            >
              {busy && <Spinner size="sm" animation="border" />} Verify & Log in
            </Button>
          ) : (
            <Button
              type="submit"
              variant="primary"
              disabled={busy}
              className="d-flex align-items-center justify-content-center gap-2"
            >
              {busy && <Spinner size="sm" animation="border" />} Send OTP
            </Button>
          )}
        </div>
      </Form>

      {/* Required container for (invisible) reCAPTCHA */}
      <div id="recaptcha-container" />
    </>
  );

  const PasswordTab = (
    <Form onSubmit={handleLogin}>
      <Form.Group className="mb-3" controlId="loginEmail">
        <Form.Label>Email</Form.Label>
        <Form.Control
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          autoComplete="username"
          placeholder="you@example.com"
          required
        />
      </Form.Group>

      <Form.Group className="mb-2" controlId="loginPassword">
        <Form.Label>Password</Form.Label>
        <Form.Control
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          autoComplete="current-password"
          placeholder="Enter your password"
          required
        />
      </Form.Group>

      <div className="d-grid mt-3">
        <Button
          type="submit"
          variant="primary"
          disabled={busy}
          className="d-flex align-items-center justify-content-center gap-2"
        >
          {busy && <Spinner size="sm" animation="border" />} Log in
        </Button>
      </div>

      {/* Divider */}
      <div className="d-flex align-items-center my-3">
        <div className="flex-grow-1 border-top" />
        <div className="px-2 text-muted small">or</div>
        <div className="flex-grow-1 border-top" />
      </div>

      {/* Google Login */}
      <div className="d-grid">
        <Button
          variant="outline-danger"
          onClick={handleGoogleLogin}
          disabled={busy}
          className="d-flex align-items-center justify-content-center gap-2"
        >
          {busy ? (
            <>
              <Spinner size="sm" animation="border" /> Connecting…
            </>
          ) : (
            <>Continue with Google</>
          )}
        </Button>
      </div>
    </Form>
  );

  return (
    <Container className="py-5">
      <Row className="justify-content-center">
        <Col xs={12} sm={10} md={8} lg={5} xl={4}>
          <Card className="shadow-sm">
            <Card.Body className="p-4">
              <h3 className="mb-3 text-center">Admin Login</h3>

              {err && (
                <Alert variant="danger" className="py-2">
                  {err?.message || "Authentication failed."}
                </Alert>
              )}

              <Nav
                variant="tabs"
                activeKey={tab}
                onSelect={(k) => setTab(k || "password")}
                className="mb-3"
              >
                <Nav.Item>
                  <Nav.Link eventKey="password">Email / Google</Nav.Link>
                </Nav.Item>
                <Nav.Item>
                  <Nav.Link eventKey="phone">Phone (OTP)</Nav.Link>
                </Nav.Item>
              </Nav>

              {tab === "password" ? PasswordTab : PhoneTab}
            </Card.Body>
          </Card>

          <div className="text-center text-muted mt-3 small">
            © {new Date().getFullYear()} — Admin Access
          </div>
        </Col>
      </Row>
    </Container>
  );
}